import { prop } from '@lib/style/theme';
import { cleanProps } from '@lib/utils';
import { CSSProperties } from 'react';
import { css } from 'styled-components';

export interface BackgroundProps {
    backgroundColor: CSSProperties['background'];
    bgc: CSSProperties['background'];
}

export const background = (backgroundColor?: BackgroundProps['backgroundColor']): any => css`
    & {
        background-color: ${prop(['bgc', 'backgroundColor'], backgroundColor)};
    }
`;

background.clean = (props): any => cleanProps(props, ['bgc', 'backgroundColor']);
